(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-campaign]').forEach(root => {
      if (root.dataset.campaignReady) return;
      const rail = root.querySelector('[data-campaign-rail]');
      if (!rail) return;
      root.dataset.campaignReady = 'true';
      const cards = [...rail.querySelectorAll('[data-campaign-card]')];
      const controls = root.querySelector('[data-campaign-controls]');
      const previous = root.querySelector('[data-campaign-prev]');
      const next = root.querySelector('[data-campaign-next]');
      const dots = root.querySelector('[data-campaign-dots]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let active = 0;
      let scheduled = false;
      const direction = () => getComputedStyle(rail).direction === 'rtl' ? -1 : 1;
      const positions = () => cards.map(card => (card.parentElement.offsetLeft - cards[0].parentElement.offsetLeft) * direction());
      const buttons = cards.map((card, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.campaignDot = String(index);
        button.setAttribute('aria-controls', rail.id);
        button.setAttribute('aria-label', dots.dataset.label.replace('__TITLE__', card.querySelector('h2').textContent.trim()));
        button.addEventListener('click', () => move(index));
        dots.append(button);
        return button;
      });
      const update = () => {
        scheduled = false;
        const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
        controls.hidden = max < 2 || cards.length < 2;
        if (controls.hidden) rail.removeAttribute('tabindex');
        else rail.tabIndex = 0;
        const positionsNow = positions();
        const offset = Math.min(max, Math.max(0, rail.scrollLeft * direction()));
        active = positionsNow.reduce((best, position, index) => Math.abs(Math.min(position, max) - offset) < Math.abs(Math.min(positionsNow[best], max) - offset) ? index : best, 0);
        if (max > 2 && offset >= max - 2) active = cards.length - 1;
        previous.disabled = offset < 2;
        next.disabled = offset >= max - 2;
        buttons.forEach((button, index) => button.setAttribute('aria-current', String(index === active)));
      };
      const move = index => {
        const target = Math.min(cards.length - 1, Math.max(0, index));
        rail.scrollTo({left: positions()[target] * direction(), behavior: motion.matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', () => move(active - 1));
      next.addEventListener('click', () => move(active + 1));
      rail.addEventListener('scroll', () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } }, {passive: true});
      rail.addEventListener('keydown', event => {
        if (event.target !== rail) return;
        const keys = {ArrowRight: active + direction(), ArrowLeft: active - direction(), Home: 0, End: cards.length - 1};
        if (!(event.key in keys)) return;
        event.preventDefault();
        move(keys[event.key]);
      });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(rail);
      else window.addEventListener('resize', update, {passive: true});
      update();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
